<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6" v-if="passData != null">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Metode Pembayaran</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          :disabled="true"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="metode name"
          class="w-full sidebar-input"
          v-model="passData.name"
          placeholder="Isi Dengan Nama Metode Pembayaran"
        />
        <span class="text-danger text-sm">{{ errors.first("metode name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Tutorial Pembayaran</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="tutorial name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Dengan Nama Tutorial Pembayaran"
        />
        <span class="text-danger text-sm">{{ errors.first("tutorial name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Tutorial Pembayaran</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vue-editor
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="tutorial name"
          v-model="formData.tutor"
        ></vue-editor>
        <span class="text-danger text-sm">{{ errors.first("tutorial name") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      formData: {
        metode_id: null,
        name: "",
        tutor: "",
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null
        ? "Edit Tutorial Pembayaran"
        : "Tambah Tutorial Pembayaran";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() && this.formData.name !== "" && this.formData.tutor !== ""
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.metode_id = this.passData.id;
        this.formData.name = this.passData.tutor ? this.passData.tutor.name : "";
        this.formData.tutor = this.passData.tutor
          ? this.richtTextFormat(this.passData.tutor.tutor)
          : "";
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.name = "";
      this.formData.tutor = "";
      this.formData.metode_id = null;
    },
    profile() {
      return JSON.parse(localStorage.getItem("profileAccess")).data;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData.tutor !== null) {
        id = {
          id: this.passData.tutor.id,
        };
      }
      this.formData.user_id = this.profile.id;
      this.$store
        .dispatch("transaksi/cudTutorialPembayaran", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Tutorial Pembayaran Sukses!"
                : "Tambah Tutorial Pembayaran Sukses!",
            text:
              this.passData !== null
                ? `Tutorial Pembayaran ${v.name} Berhasil diedit`
                : `Tutorial Pembayaran ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>
